import {
  Coins,
  Wand2,
  LayoutTemplate,
  MessageCircle,
  SlidersHorizontal,
  Paintbrush,
  CreditCard,
  BarChart3,
  ShoppingCart,
  type LucideIcon,
} from "lucide-react";

export interface NewsSlide {
  id: number;
  /** URL de imagen — cuando existe, el slide muestra solo la imagen */
  imageUrl?: string;
  /** Contenido placeholder (se usa solo si NO hay imageUrl) */
  title?: string;
  bullets?: string[];
  ctaText?: string;
  ctaUrl?: string;
  /** Icono decorativo del slide placeholder */
  decorativeIcon?: LucideIcon;
  /** Icono para la lista de noticias debajo del carrusel */
  listIcon: LucideIcon;
  /** Titulo para la lista de noticias */
  listTitle: string;
}

/** Mapeo de strings del JSON remoto a iconos Lucide */
export const ICON_MAP: Record<string, LucideIcon> = {
  Coins,
  Wand2,
  LayoutTemplate,
  MessageCircle,
  SlidersHorizontal,
  Paintbrush,
  CreditCard,
  BarChart3,
  ShoppingCart,
};

/** URL del JSON remoto en S3/CDN */
export const NEWS_JSON_URL =
  "https://fluxi.co/prod/assets/banners/home-news.json";

/** Intervalo de auto-rotacion por defecto (ms) */
export const DEFAULT_AUTO_ROTATE_MS = 30000;

/** Slides por defecto (fallback si el fetch falla) */
export const DEFAULT_SLIDES: NewsSlide[] = [
  {
    id: 1,
    imageUrl: "https://fluxi.co/prod/assets/banners/02-crear-paginas.webp",
    listIcon: LayoutTemplate,
    listTitle: "Nueva forma de crear páginas con plantillas personalizadas",
  },
  {
    id: 2,
    imageUrl: "https://fluxi.co/prod/assets/banners/03-plantillas.webp",
    listIcon: Paintbrush,
    listTitle: "Plantillas personalizadas para tus páginas",
  },
  {
    id: 3,
    imageUrl: "https://fluxi.co/prod/assets/banners/04-checkout.webp",
    listIcon: CreditCard,
    listTitle: "Nuevo checkout con estilos modernos y testimonios",
  },
  {
    id: 4,
    imageUrl: "https://fluxi.co/prod/assets/banners/05-analytics.webp",
    listIcon: BarChart3,
    listTitle: "Nuevo módulo de Analytics de eventos por página",
  },
  {
    id: 5,
    imageUrl: "https://fluxi.co/prod/assets/banners/06-carritos.webp",
    listIcon: ShoppingCart,
    listTitle: "Nueva funcionalidad de Carritos abandonados",
  },
];
